import { Component, Input } from '@angular/core';
import { SharedModule } from '../../shared.module';

@Component({
  selector: 'app-form-api-validation-errors',
  standalone: false,
  //imports: [SharedModule],
  templateUrl: './form-api-validation-errors.component.html',
  styleUrls: ['./form-api-validation-errors.component.scss'],
})
export class FormApiValidationErrorsComponent {
  @Input() errors!: Map<string, string[]> | null;;
}
